module.exports = __webpack_public_path__ + "static/media/tr.ac4572cc.svg";